import React from "react";
import "./MapComponent.css";

const MapComponent = () => {
  return (
    <>
      <section className="MapComponent">
        <div className="embed-map-responsive">
          <div className="embed-map-container">
            <iframe
              className="embed-map-frame"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://maps.google.com/maps?q=IT%20Pulse%20Udaipur&t=&z=17&ie=UTF8&iwloc=&output=embed"
              title="Google Map"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default MapComponent;
